<div [class.dark-theme]="true" class="fix-action-dialog">
	<div fxLayout="row" fxlayoutalign="space-between">
		<h2 mat-dialog-title style="font-size: 17px;color:#ffffff;font-weight: 600;"><span data-idtest="aigia-logout-dialog-t-4Qz" translate>{{content.title}}</span></h2>
	</div>
	<div class="spacer"></div>
	<mat-dialog-content class="logout-card-dialog" fxLayout="column" style="font-size: 15px;padding: 32px 12px;">
		<mat-card>
			<mat-card-content>
				<div><span data-idtest="aigia-logout-dialog-t-0Lt" translate>{{content.description}}</span></div>
			</mat-card-content>
		</mat-card>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.lt-sm="space-between center" style="color:#ffffff;font-size:10px;">
		<div fxFlex="40" fxLayoutAlign="center center" style="padding-top:32px;">
			<button [disabled]="isProgress" color="warn" mat-dialog-close="" mat-stroked-button><span data-idtest="aigia-logout-dialog-t-8Cx" translate>キャンセル</span></button>
		</div>
		<div fxFlex="40" fxLayoutAlign="center center" style="padding-top:32px;">
			<button data-idtest="aigia-logout-dialog-b-3Ea" (click)="onAccept()" [disabled]="isProgress" color="primary" mat-raised-button><span data-idtest="aigia-logout-dialog-t-5Vj" translate>ログアウト</span></button>
		</div>
	</mat-dialog-actions>
</div>
